var _defs, _rect, _line, _line2, _line3, _line4, _line5, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectifier01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t.cls-1, .cls-2 {\n\t\tfill: #fff;\n\t\tstroke: #000;\n\t\tstroke-miterlimit: 10;\n\t\t}\n\n\t\t.cls-1 {\n\t\tstroke-width: 0.25px;\n\t\t}\n\n\t\t.cls-2 {\n\t\tstroke-width: 0.1px;\n\t\t}\n\t"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectifier") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.18,
    y: 6,
    width: 8.31,
    height: 4.78
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.18,
    y1: 10.78,
    x2: 12.49,
    y2: 6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.13,
    y1: 9.37,
    x2: 11.32,
    y2: 9.37
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.13,
    y1: 10.09,
    x2: 9.67,
    y2: 10.09
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.95,
    y1: 10.09,
    x2: 10.5,
    y2: 10.09
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.78,
    y1: 10.09,
    x2: 11.32,
    y2: 10.09
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.91,7.32c.08-.29.24-.5.38-.5s.26.22.36.4.12.43.24.51.51,0,.67-.26a.61.61,0,0,0,.13-.35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectifier01);
export default __webpack_public_path__ + "static/media/Rectifier-01.29b42fc84a9f64f4aaa6e8d718f09831.svg";
export { ForwardRef as ReactComponent };